import { Injectable } from '@angular/core';
import { Firestore, collection, query, where, getDocs, Timestamp } from '@angular/fire/firestore';
import { Observable, from, map } from 'rxjs';
import { FirestoreCrudService } from './crudService';
import { IOntapTVPendingConnection } from 'app/models/ontapTVPendingConnections';
import { dbConst } from './databaseConstants';
import { Store } from '@ngrx/store';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class OntaptvPendingConnectionsService {
  private crudService: FirestoreCrudService<IOntapTVPendingConnection>;
  constructor(
    firestore: Firestore,
    private store: Store,
    authService: AuthService) {
    this.crudService = new FirestoreCrudService<IOntapTVPendingConnection>(
      firestore, authService, dbConst.ontapTVPendingConnections);
  }


  /**
   * Get a connection by ID
   */
  getById(id: string): Observable<IOntapTVPendingConnection | undefined> {
    return this.crudService.get(id);
  }

  getByIdOnce(id: string): Promise<IOntapTVPendingConnection | undefined> {
    return this.crudService.getOnce(id);
  }

  /**
   * Update connection status
   */
  async updateConnectionStatus(
    id: string,
    status: 'pending' | 'connected',
    connectedBarId?: string
  ): Promise<void> {
    const updates: Partial<IOntapTVPendingConnection> = { status };
    if (connectedBarId) {
      updates.barId = connectedBarId;
    }
    await this.crudService.softUpdate(id, updates);
  }

}
